import styled from 'styled-components';
import { Skeleton } from '@gif/shared-ui';

import { Game } from '../../types';
import { translate } from '../../configs';
import { getGameUrl } from '../../utils';
import { GameCard } from '..';

const Title = styled.h2`
  font-size: 1.1875rem;
  font-weight: 600;
  line-height: 120%;
  margin: 0;
`;

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
`;

const ListContainer = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  flex-wrap: wrap;

  @media screen and (min-width: 600px) and (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: 375px) and (max-width: 599px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 374px) {
    grid-template-columns: repeat(1, 1fr);
    align-self: center;
  }
`;

const loadingCards = Array.from(Array(6), (_, index) => (
  <GameCard key={index} isLoading={true} />
));

export interface GamesListProps {
  className?: string;
  games?: Game[];
  title?: string;
  onGameCardClick: (e: React.MouseEvent, i: number) => void;
  branchDataGroupId?: string;
  isLoading?: boolean;
}

export function GamesList({
  className,
  games = [],
  title = 'All Games',
  onGameCardClick,
  branchDataGroupId,
  isLoading = false,
}: GamesListProps) {
  if (isLoading) {
    return (
      <>
        <Skeleton height="1.1875rem" width="20%" />
        <ListContainer>{loadingCards}</ListContainer>
      </>
    );
  }

  // TODO: pagination should be done here
  return (
    <Container className={className}>
      <Title>{title}</Title>
      {games.length ? (
        <ListContainer>
          {games.map((game, i) => (
            <GameCard
              key={game?.gameId}
              game={{
                ...game,
                uri: getGameUrl(games, game?.gameId, branchDataGroupId),
              }}
              onClick={(e) => onGameCardClick(e, i)}
            />
          ))}
        </ListContainer>
      ) : (
        <p>{translate('noGamesAvailable')}</p>
      )}
    </Container>
  );
}

export default GamesList;
